import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22Fonts.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../public/fonts/Corporate-Logo-Medium-ver3.woff2%22,%22weight%22:%22500%22},{%22path%22:%22../../public/fonts/Corporate-Logo-Bold-ver3.woff2%22,%22weight%22:%22700%22}],%22variable%22:%22--font-corp%22,%22display%22:%22swap%22}],%22variableName%22:%22corp%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'corp', 'corp Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
